export default function CustomFadePlugin({ swiper }) {
  const setTranslate = () => {
    const { slides } = swiper

    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = swiper.slides.eq(i)
      const offset = slideEl[0].swiperSlideOffset

      let translateX = -offset
      let translateY = 0

      slideEl.transform(`translate3d(${translateX}px, ${translateY}px, 0px)`)
    }
  }

  const setTransition = duration => {
    swiper.slides.transition(duration)
  }

  return {
    setTransition,
    setTranslate,
  }
}
